import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../../classes';
import { BsModalService } from 'ngx-bootstrap';
import { ProductsService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';
import { Event } from '../../../../interfaces';
import { VolumeDiscountApi } from '../../../../../assets/js/lb-sdk';
import { VolumeDiscountFormComponent } from './volume-discount-form/volume-discount-form.component';
import { VOLUME_DISCOUNT_UNITS, MERCHANT_TYPE, PAYMENT_TYPE } from '../../../../enums';

@Component({
  selector: 'app-volume-discounts',
  templateUrl: './volume-discounts.component.html',
  styleUrls: ['./volume-discounts.component.css']
})
export class VolumeDiscountsComponent extends BasicList {
  VOLUME_DISCOUNT_UNITS: typeof VOLUME_DISCOUNT_UNITS = VOLUME_DISCOUNT_UNITS;

  constructor(
    private volumeDiscountApi: VolumeDiscountApi,
    private modalService: BsModalService,
    private productsService: ProductsService,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productsService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'merchantType', placeholder: 'Merchant Type', options: MERCHANT_TYPE },
        { name: 'paymentType', placeholder: 'Payment Type', options: PAYMENT_TYPE }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: VolumeDiscountFormComponent,
      api: this.volumeDiscountApi,
      ModalService: this.modalService
    };
  }

  modify(data) {
    const { id, productType, merchantType, paymentType, unit, minimum, discount } = data;
    this.edit({
      id,
      productType: this.productsService.getProductTypeByName(productType),
      merchantType,
      paymentType,
      discount,
      unit,
      minimum
    });
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Volume discount successfully created', 'Volume Discount');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Volume discount successfully updated', 'Volume Discount');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Volume discount successfully deleted', 'Volume Discount');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }
}
